var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40963",
    "data-name": "Group 40963",
    transform: "translate(-143 -423)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15547",
    "data-name": "Rectangle 15547",
    width: 24,
    height: 24,
    transform: "translate(143 423)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pay",
    transform: "translate(129.5 409.49)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3147",
    "data-name": "Ellipse 3147",
    cx: 5.882,
    cy: 5.882,
    rx: 5.882,
    ry: 5.882,
    transform: "translate(19.618 15.009)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37259",
    "data-name": "Path 37259",
    d: "M25.62,341.252H29.5l2.3-2.3a3.207,3.207,0,0,1,4.2-.292h0L30.863,343.8a2.243,2.243,0,0,1-1.586.657H15v-4.041h1.365a4.9,4.9,0,0,1,7.387-1.949h2.178a2.259,2.259,0,0,1,2.259,2.259v.528H23.146",
    transform: "translate(0 -308.447)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37260",
    "data-name": "Path 37260",
    d: "M227.217,91.993a1.552,1.552,0,0,0-1.388-.217,1.073,1.073,0,0,0-.456,1.766,5.17,5.17,0,0,0,1.418.671,1.3,1.3,0,0,1-.549,2.514,1.933,1.933,0,0,1-1.322-.356",
    transform: "translate(-200.774 -73.352)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3354",
    "data-name": "Line 3354",
    y2: 0.434,
    transform: "translate(25.468 23.673)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3355",
    "data-name": "Line 3355",
    y2: 0.472,
    transform: "translate(25.468 17.674)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectPayment);
export default __webpack_public_path__ + "static/media/collect-payment.f3c07e8622a6cacf0920f71dd596f12a.svg";
export { ForwardRef as ReactComponent };